/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationreasonother2Inputs */

const en_moderationreasonother2 = /** @type {(inputs: Moderationreasonother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_moderationreasonother2 = /** @type {(inputs: Moderationreasonother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Moderationreasonother2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreasonother2 = /** @type {((inputs?: Moderationreasonother2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreasonother2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreasonother2(inputs)
	return de_moderationreasonother2(inputs)
});
export { moderationreasonother2 as "moderationReasonOther" }